import configureAppStore from "./configureStore";

export const store = configureAppStore(window.__INITIAL_STATE__);
